<template>
  <div class="detailedbox">
    <div v-if="fieldlist.length" class="drawerpage">
      <div class="form_boxs" v-for="(item1, index1) in createlist">
        <label class="tit_left"
          ><i
            class="el-icon-collection-tag"
            style="font-size: 12px; color: #2b75ebff; margin-right: 8px"
          ></i
          >{{ item1.name }}</label
        >
        <div class="form_item_left">
          <template v-for="(value, index) in fieldlist">
            <div class="items" v-if="value.type == item1.type && value.is_show">
              <div class="tit">{{ value.field }}</div>
              <!-- 单行 -->
              <el-input
                v-if="value.field_type === 1"
                :maxlength="value.maxLength"
                :disabled="value.disabled"
                v-model="value.content"
                placeholder="请输入内容"
                :class="
                  value.length === 1
                    ? 'input_w230'
                    : value.length === 0
                    ? 'input_w460'
                    : value.length === 2
                    ? 'input_w690'
                    : value.length === 3
                    ? 'input_w920'
                    : 'input_w460'
                "
              >
              </el-input>
              <!--  -->
              <!-- 多行 -->
              <el-input
                v-else-if="value.field_type === 2"
                :maxlength="value.maxLength"
                :disabled="value.disabled"
                type="textarea"
                :rows="1"
                placeholder="请输入内容"
                v-model="value.content"
                :class="
                  value.length === 1
                    ? 'input_w230'
                    : value.length === 0
                    ? 'input_w460'
                    : value.length === 2
                    ? 'input_w690'
                    : value.length === 3
                    ? 'input_w920'
                    : 'input_w460'
                "
              >
              </el-input>
              <!--  -->
              <!-- 时间 -->
              <el-date-picker
                v-else-if="value.field_type === 3"
                v-model="value.content"
                :disabled="value.disabled"
                value-format="timestamp"
                type="date"
                :class="
                  value.length === 1
                    ? 'input_w230'
                    : value.length === 0
                    ? 'input_w460'
                    : value.length === 2
                    ? 'input_w690'
                    : value.length === 3
                    ? 'input_w920'
                    : 'input_w460'
                "
                placeholder="选择日期"
              >
              </el-date-picker>
              <!--  -->
              <!-- 数字 -->
              <el-input
                v-else-if="value.field_type === 4"
                :maxlength="value.maxLength"
                :disabled="value.disabled"
                v-model="value.content"
                placeholder="请输入内容"
                oninput="value=value.replace(/[^0-9.]/g,'')"
                :class="
                  value.length === 1
                    ? 'input_w230'
                    : value.length === 0
                    ? 'input_w460'
                    : value.length === 2
                    ? 'input_w690'
                    : value.length === 3
                    ? 'input_w920'
                    : 'input_w460'
                "
              >
              </el-input>
              <!--  -->
              <!-- 单选 -->
             
              <template v-else-if="value.field_type === 5 && value.field != '客户模板'">
              <el-select
                
                v-model="value.content"
                :disabled="value.disabled"
                :class="
                  value.length === 1
                    ? 'input_w230'
                    : value.length === 0
                    ? 'input_w460'
                    : value.length === 2
                    ? 'input_w690'
                    : value.length === 3
                    ? 'input_w920'
                    : 'input_w460'
                "
              >
                <el-option
                  v-for="(item2, index2) in value.field_list"
                  :key="item2.name"
                  :label="item2.name"
                  :value="item2.id"
                >
                </el-option>
              </el-select>
              </template>
              <!--  -->
              <!-- 多选 -->
              <el-select
                v-else-if="value.field_type === 6"
                multiple
                collapse-tags
                v-model="value.content"
                :disabled="value.disabled"
                :class="
                  value.length === 1
                    ? 'input_w230'
                    : value.length === 0
                    ? 'input_w460'
                    : value.length === 2
                    ? 'input_w690'
                    : value.length === 3
                    ? 'input_w920'
                    : 'input_w460'
                "
              >
                <el-option
                  v-for="(item2, index2) in value.field_list"
                  :key="item2.name"
                  :label="item2.name"
                  :value="item2.id"
                >
                </el-option>
              </el-select>
              <!-- -------------------------------- -->
              <!--  附件信息 -->
              <div v-else-if="value.field_type === 7">
                <!-- 附件 -->
                <enclofile
                  :btnshow="false"
                  :disabled="value.disabled"
                  :enclist="value.content"
                  :fieldid="value.id"
                  @fndelet="fndelet"
                  @setupfile="setupfile"
                  accept=".docx,.doc,.xlsx,.xls,.pptx,.ppt,.pdf"
                >
                </enclofile>
                <!--  -->
              </div>
              <!--  图片 -->
              <div v-else-if="value.field_type === 8">
                <!-- 图片 -->
                <enclofile
                  :btnshow="false"
                  :disabled="value.disabled"
                  :enclist="value.content"
                  :fieldid="value.id"
                  :filenum="value.filenum"
                  @fndelet="fndelet"
                  @setupfile="setupfile"
                  accept=".png,.jpg,.jpeg"
                >
                </enclofile>
                <!--  -->
              </div>
              <!--  -->
              <!--  产品信息 -->
              <div v-else-if="value.field_type === 9">
                <!-- 产品 -->
                <addproduct
                  :isnodata="false"
                  :show="!loading"
                  :btnshow="false"
                  :disabled="value.disabled"
                  :pro_list="value.content"
                  :fieldid="value.field_id"
                  @eidht="headeidht"
                  @deleteds="headdeleteds"
                  @pushpro="headpushpro"
                  @procomkl="headprocomkl"
                ></addproduct>
                <!--  -->
              </div>
              <!--  -->
              <!-- 负责人 -->
              <el-select
                v-else-if="value.field_type === 10"
                filterable
                v-model="value.content"
                placeholder="请选择"
                :disabled="value.disabled"
                class="input_w460"
              >
                <el-option
                  v-for="(item2, index2) in member_list"
                  :key="item2.name"
                  :label="item2.name"
                  :value="item2.member_id"
                >
                </el-option>
              </el-select>
              <!--  -->
              <!-- 协同人 -->
              <el-select
                v-else-if="value.field_type === 11"
                v-model="value.content"
                filterable
                multiple
                collapse-tags
                :disabled="value.disabled"
                placeholder="请选择"
                class="input_w460"
              >
                <el-option
                  v-for="(item2, index2) in member_list"
                  :key="item2.member_id"
                  :label="item2.name"
                  :value="item2.member_id"
                >
                </el-option>
              </el-select>
              <!--  -->
              <!-- 客户 -->
              <el-select
                v-else-if="value.field_type === 12"
                v-model="value.content"
                filterable
                placeholder="请选择"
                :disabled="value.disabled"
                @change="changeCustomer"
                class="input_w460"
              >
                <el-option
                  v-for="(item2, index2) in CustomerList"
                  :key="item2.customer_id"
                  :label="item2.customer_name"
                  :value="item2.customer_id"
                >
                </el-option>
              </el-select>
              <!--  -->

              <!-- 关联 商机 -->
              <el-select
                v-else-if="value.field_type === 13"
                v-model="value.content"
                clearable
                :disabled="chance_charge"
                filterable
                placeholder="请选择"
                class="input_w460"
              >
                <el-option
                  v-for="(item2, index2) in chance_list"
                  :key="item2.chance_id"
                  :label="item2.name"
                  :value="item2.chance_id"
                >
                </el-option>
              </el-select>
              <!--  -->
              <!-- 关联 合同 -->
              <el-select
                v-else-if="value.field_type === 14"
                :disabled="contract_charge"
                clearable
                v-model="value.content"
                filterable
                placeholder="请选择"
                class="input_w460"
              >
                <el-option
                  v-for="(item2, index2) in contract_list"
                  :key="item2.contract_id"
                  :label="item2.name"
                  :value="item2.contract_id"
                >
                </el-option>
              </el-select>
              <!--  -->
              <!-- 联系人选择 -->
              <el-select
                v-else-if="value.field_type === 17"
                :disabled="value.disabled"
                clearable
                v-model="value.content"
                filterable
                placeholder="请选择联系人"
                class="input_w460"
              >
                <el-option
                  v-for="(item2, index2) in contactslist"
                  :key="item2.contract_id"
                  :label="item2.name"
                  :value="item2.contract_id"
                >
                </el-option>
              </el-select>
              <!-- 模板选择 -->
			  <template v-else-if="value.field_type === 18">
			  <el-select
			    
			    v-model="value.content"
			    :disabled="value.disabled"
			    :class="
			      value.length === 1
			        ? 'input_w230'
			        : value.length === 0
			        ? 'input_w460'
			        : value.length === 2
			        ? 'input_w690'
			        : value.length === 3
			        ? 'input_w920'
			        : 'input_w460'
			    "
			  >
			    <el-option
			      v-for="(item2, index2) in value.field_list"
			      :key="item2.form_id"
			      :label="item2.name"
			      :value="item2.form_id"
			    >
			    </el-option>
			  </el-select>
			  </template>

              <!--  -->
              <!--  -->
            </div>
          </template>
          <!--  -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var that;

import {
  get_membelist,
  gchance_list,
  get_contracTlist,
  getuser_info,
} from "network/hk_operset";
import { getCustomerList } from "network/hk_customer";
import { kh_customer_list, xs_cue_pool_list } from "network/kh_public";
import addproduct from "components/content/addproduct/addproduct";
import enclofile from "components/content/addproduct/enclofile";
export default {
  components: {
    addproduct,
    enclofile,
  },
  name: "newdetailedbox",

  props: {
    //
    createlist: {
      type: Array,
      default: () => {
        return [];
      },
    },
    fieldlist: {
      type: Array,
      default: () => {
        return [];
      },
    },

    //
    allCusts: {
      type: Boolean,
      default: false,
    },
    // 有什么 创建关联 1: 商机， 2: 合同；
    isrelation: {
      type: Number,
      default: 0,
    },

    // 基础数据 是否加载完成
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      urlhead: "https://scrm.51kuaiding.com/scrm/hktxcx/customer",

      member_list: [],
      CustomerList: [],
      chance_list: [],
      contract_list: [],

      chance_charge: true,
      contract_charge: true,

      member_id: "",

      contactslist: [],
    };
  },

  created() {
    that = this;
    //
  },
  watch: {
    loading() {
      if (!this.loading) {
        let flag1 = this.findTpye(10);
        let flag2 = this.findTpye(11);
        if (flag1 || flag2) {
          // 获取所有 成员
          this.fn_get_membelist();
        }
        let flag3 = this.findTpye(12);
        if (flag3) {
          // 获取 客户
          this.fn_getuser();
        }
      }
    },
  },
  methods: {
    // 附件 删除 field_type === 11
    fndelet(e) {
      this.$emit("fjdelet", e);
    },
    picdelet(e) {
      this.$emit("fnpicdelet", e);
    },
    // 附件 新增
    setupfile(e) {
      this.$emit("fjadds", e);
    },
    picupfile(e) {
      this.$emit("fnpicupfile", e);
    },
    //
    // 产品 ----------------- field_type === 10
    // 编辑确定
    headeidht(e) {
      this.$emit("cpedits", e);
    },
    // 删除确定
    headdeleteds(e) {
      this.$emit("cpdelet", e);
    },
    // 自定义产品 确定
    headpushpro(e) {
      this.$emit("cppush", e);
    },
    // 选择产品 确定
    headprocomkl(e) {
      this.$emit("cpcomk", e);
    },
    // -----------------

    // 获取所有 成员
    fn_get_membelist() {
      get_membelist().then((res) => {
        if (this.handlereq(res)) {
          this.member_list = res.result.data;
        }
      });
    },
    // 获取个人信息
    fn_getuser() {
      let memberid = this.$store.state.member_id || localStorage.member_id;
      console.log(memberid, "memberid");
      if (memberid) {
        this.member_id = memberid * 1;
        // 获取客户列表
        this.fn_getCusList();
      } else {
        getuser_info().then((res) => {
          if (this.handlereq(res)) {
            let { member_id, member_name, store_id } = res.result;
            localStorage.setItem("member_id", member_id);
            localStorage.setItem("member_name", member_name);
            this.member_id = member_id * 1;
            this.member_name = member_name;
            console.log(this.member_id, "this.member_id");
            that.$store.commit("setMemberId", member_id);
            that.$store.commit("setMemberName", member_name);
            // 获取客户列表
            this.fn_getCusList();
          }
        });
      }
    },
    // 获取客户列表
    fn_getCusList() {
      // let pagesize = 999
      // let page = 1
      // let search_name = ''
      // let member_id = '' // 获取所有客户

      // if(this.allCusts) {  // 获取 指定所属人 客户
      // 	member_id = this.member_id * 1
      // }
      // getCustomerList(pagesize, page, search_name, member_id).then(res => {
      // 	if (this.handlereq(res)) {
      // 		this.CustomerList = res.result.data
      // 	}
      // })

      let data = {
        sort_type: 1, //  否	string	排序类型 1:最新释放2:最新创建3:最新访问4:最新跟进
        pagesize: 999, //  	是	int	每页数量
        page: 1,
        class_type: 0,
      };
      if (this.allCusts) {
        // 获取 指定所属人 客户
        data.class_type = 1;
      }
      kh_customer_list(data).then((res) => {
        if (this.handlereq(res)) {
          this.CustomerList = res.result.data;
        }
      });
    },
    findTpye(field_type) {
      return this.fieldlist.some((v) => v.field_type == field_type);
    },

    // 选择客户后
    changeCustomer(customer_id) {
      console.log(customer_id, "changeCustomer");
      let flag1 = this.findTpye(13);
      let flag2 = this.findTpye(14);

      if (customer_id) {
        // 获取 当前客户的 关联-商机、合同
        if (this.isrelation == 1 && flag1) {
          // 商机
          this.fn_gchance_list(customer_id);
        } else if (this.isrelation == 2 && flag2) {
          // 合同
          this.fn_contract_list(customer_id);
        }
      }
    },
    // 获取 商机 列表
    fn_gchance_list(customer_id) {
      let data = {
        pagesize: 999,
        page: 1,
        customer_id,
      };

      gchance_list(data).then((res) => {
        if (this.handlereq(res)) {
          this.chance_list = res.result.data;
          this.chance_charge = false;
        }
      });
    },
    // 获取 合同 列表
    fn_contract_list(customer_id) {
      let data = {
        pagesize: 999,
        page: 1,
        customer_id,
      };
      get_contracTlist(data).then((res) => {
        if (this.handlereq(res)) {
          this.contract_list = res.result.data;
          this.contract_charge = false;
        }
      });
    },

    // 弹出提示
    alertMess(message, type) {
      this.$message({
        showClose: true,
        offset: 100,
        duration: 2000,
        message,
        type: type ? type : "success",
      });
    },
    handlereq(res) {
      if (res) {
        if (res.code === 10000) {
          // 请求成功
          return true;
        } else {
          // 请求发生错误
          this.alertMess(res.message, "error");
          return false;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .el-input.is-disabled .el-input__inner {
  color: rgba(96, 98, 102, 1) !important;
}

/deep/ .detailedbox .el-form-item {
  width: 100%;
}

/deep/ .detailedbox .el-form-item__content {
  width: 500px !important;
}

.form_boxs {
  .form_tit {
    margin-bottom: 20px;
    font-size: 16px;
    color: #000;
    font-weight: 550;
    display: flex;
    align-items: center;
  }

  .form_tit2::before {
    content: "";
    display: block;
    width: 3px;
    height: 20px;
    background: rgba(43, 117, 235, 1);
    margin-right: 9px;
  }

  .form_content {
    margin-bottom: 40px;
  }

  /deep/ .form_content .el-input {
    width: 500px;
  }

  /deep/ .form_content .el-textarea {
    width: 500px;
  }

  /deep/ .form_content .el-textarea textarea {
    color: #606266;
  }
}
.eltabs_minute_tit {
  color: #2e405e;
  display: block;
  font-size: 14px;
  font-weight: bolder;
  text-transform: none;
  margin-bottom: 14px;
}
.eltabs_minute_form {
  display: flex;
  margin-bottom: 23px;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  .eltabs_minute_items {
    display: flex;
    .eltabs_minute_label {
      width: 135px;
      height: 40px;
      line-height: 40px;
      color: #909aaaff;
      background-color: #fafbfbff;
      border: 1px solid #eeeeeeff;
      padding-left: 15px;
    }
    .eltabs_minute_text {
      width: 215px;
      height: 40px;
      line-height: 40px;
      opacity: 1;
      color: #2e405eff;
      background: #ffffffff;
      border: 1px solid #eeeeeeff;
      padding-left: 15px;
    }
  }
}
.items {
  display: flex;
  flex-direction: column;
  margin-bottom: 13px;
  margin-right: 18px;
  .consactzs {
    width: 100%;
    display: flex;
    margin-bottom: 13px;
    flex-direction: column;
  }
}
.form_item_left {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.tit_left {
  color: #2e405e;
  display: block;
  font-size: 16px;
  font-weight: bolder;
  text-transform: none;
  margin-bottom: 19px;
}
.tit {
  color: #2e405e;
  display: block;
  font-size: 14px;
  font-weight: bolder;
  text-transform: none;
  margin-bottom: 5px;
}
.input_w920 {
  width: 928px;
  height: 32px;
}
.input_w460 {
  width: 453px;
  height: 32px;
}
.input_w690 {
  width: 695px;
  height: 32px;
}
.input_w230 {
  width: 218px;
  height: 32px;
}
</style>
